<!--https://github.com/angular/components/issues/4580#issuecomment-1423197872-->
<mat-form-field [subscriptSizing]="data.subscriptSizing ?? 'fixed'">
  @if (data.label) {
    <mat-label>{{ data.label }}</mat-label>
  }

  <mat-date-range-input [rangePicker]="picker" [formGroup]="rangeFormGroup">
    <input
      matStartDate
      (dateChange)="startChanged($event)"
      (dateInput)="updateValidity()"
      formControlName="start"
      placeholder="Von"
      [data]="stateStart"
      uiFormInputAttributes
    />
    <input
      matEndDate
      (dateChange)="endChanged($event)"
      (dateInput)="updateValidity()"
      formControlName="end"
      placeholder="Bis"
      [data]="stateEnd"
      uiFormInputAttributes
    />
  </mat-date-range-input>

  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-date-range-picker>

  <mat-error [control]="controlStart.errors ? controlStart : controlEnd" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerHtml]="data.hint"></mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
